/**
 * Firebase web config (proyecto website-9efa7 — compartido con portal).
 * No secretos; API key pública de cliente.
 */
export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBPAUvh5dIqHmeVbkBy8ISP9pEL-Q_tdcY',
  authDomain: 'website-9efa7.firebaseapp.com',
  projectId: 'website-9efa7'
};
